import { Component, ElementRef, inject, input, OnDestroy, output, signal } from '@angular/core';
import { CanvasArrowComponent } from '@features/canvas/canvas-arrow/canvas-arrow.component';
import { Ticker } from '@shared/misc.utils';
import { Vector2, Vector2CanvasNormalized } from '@typings/vectors';

@Component({
  selector: 'lp-canvas-renderer-arrows',
  imports: [CanvasArrowComponent],
  templateUrl: './lp-canvas-renderer-arrows.component.html',
  host: {
    '[style.position]': "'absolute'",
    '[style.inset]': '0',
    '[style.pointerEvents]': "'none'",
  },
  styleUrl: './lp-canvas-renderer-arrows.component.css',
})
export class LpCanvasRendererArrowsComponent implements OnDestroy {
  origin = input.required<Vector2CanvasNormalized>();
  size = input.required<Vector2CanvasNormalized>();
  el = inject<ElementRef<HTMLElement>>(ElementRef);

  screenSize = signal([0, 0] as Vector2);

  screenSizeUpdated = output<Vector2>();

  private ticker: Ticker;

  constructor() {
    // TODO: get the canvas size in another way
    this.ticker = new Ticker(() => {
      this.screenSize.set([this.el.nativeElement.clientWidth, this.el.nativeElement.clientHeight] as Vector2);
      this.screenSizeUpdated.emit(this.screenSize());
    });
  }

  ngOnDestroy(): void {
    this.ticker.stop();
  }
}
